module.exports = __webpack_public_path__ + "img/50.13a05d4e.jpg";